import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import authEn from '../translator/utilities/en/auth.json';
import commonEn from '../translator/utilities/en/common.json';
import errorMessagesEn from '../translator/utilities/en/errors.json';
import SectionsEn from '../translator/utilities/en/secions.json';
import jobTitleEn from '../translator/utilities/en/JobTitle.json';
import placeholderTextEn from '../translator/utilities/en/placeholder.json';
import labelEn from '../translator/utilities/en/label.json';
import actionEn from '../translator/utilities/en/action.json';
import salarySystemEn from '../translator/utilities/en/salarySystem.json';
import DayEn from '../translator/utilities/en/days.json';

import authAr from '../translator/utilities/ar/auth.json';
import commonAr from '../translator/utilities/ar/common.json';
import errorMessagesAr from '../translator/utilities/ar/errors.json';
import SectionsAr from '../translator/utilities/ar/sections.json';
import jobTitleAr from '../translator/utilities/ar/JobTitle.json';
import placeholderTextAr from '../translator/utilities/ar/placeholder.json';
import labelAr from '../translator/utilities/ar/label.json';
import actionAr from '../translator/utilities/ar/action.json';
import salarySystemAr from '../translator/utilities/ar/salarySystem.json';
import DayAr from '../translator/utilities/ar/days.json';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const resources = {
    en: {
        auth: authEn,
        common: commonEn,
        error: errorMessagesEn,
        sections: SectionsEn,
        jb: jobTitleEn,
        placeholder: placeholderTextEn,
        label: labelEn,
        action: actionEn,
        salarySystem: salarySystemEn,
        days: DayEn
    },
    ar: {
        auth: authAr,
        common: commonAr,
        error: errorMessagesAr,
        sections: SectionsAr,
        jb: jobTitleAr,
        placeholder: placeholderTextAr,
        label: labelAr,
        action: actionAr,
        salarySystem: salarySystemAr,
        days: DayAr
    },
};

i18n
    .use(initReactI18next)
    .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;